import React, { useState } from "react";
import { InputWithLabel } from "../../components/micro/input";
import LoginIcon from "../../assets/image/logo.png";
import { useNavigate, useParams } from "react-router-dom";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { Eye, EyeSlash } from "iconsax-react";
import { useDispatch } from "react-redux";
import { newPassword } from "../../redux/auth/slice";

const NewPassword = () => {
  const [passwordType, setPasswordType] = useState("password");
  const [loading, setLoading] = useState(false);
  const { email, token } = useParams();
  const [confirmPasswordType, setConfirmPasswordType] = useState("password");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return (
    <>
      <div className={`h-screen overflow-hidden relative`}>
        <div className={`flex items-center justify-center h-full`}>
          <section className="w-full">
            <div className="max-w-xl w-full mx-auto">
              <div className="flex justify-center mb-4">
                <img src={LoginIcon} alt="logo" className="object-cover w-40" />
              </div>
              <div className="rounded-lg drop-shadow-lg bg-white px-6 py-8 mx-4 border border-gray shadow-lg">
                <div className={"mb-8"}>
                  <h1 className="sm:text-2xl text-2xl text-primaryBlack font-Montserrat font-normal mb-1">
                    New Password!
                  </h1>
                  <p className="text-sm text-textSecondary font-normal font-Proxima">
                    Key in your new password
                  </p>
                </div>
                {/* Login flow */}
                <Formik
                  initialValues={{
                    password: "",
                    confirmPassword: "",
                    // role: "admin",
                  }}
                  validationSchema={Yup.object({
                    password: Yup.string().required(
                      "Please enter new password"
                    ),
                    confirmPassword: Yup.string()
                      .required("Please enter confirm new password")
                      .oneOf(
                        [Yup.ref("password"), null],
                        "Passwords must match"
                      ),
                  })}
                  onSubmit={(values) => {
                    setLoading(true);
                    dispatch(
                      newPassword({ email: email, code: token, ...values })
                    ).then((res) => {
                      setLoading(false);
                      if (res.type === "newPassword/fulfilled") {
                        navigate("/password-successful");
                      }
                    });
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                  }) => (
                    <Form onSubmit={handleSubmit}>
                      <div className="space-y-5">
                        {/* New Password */}
                        <InputWithLabel
                          className={`border border-gray ${
                            errors.password && touched.password
                              ? "border-red"
                              : values.password
                              ? "border-themeBtn"
                              : ""
                          }`}
                          idFromName="password"
                          label="New Password"
                          type={passwordType}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.password}
                          errors={errors.password && touched.password}
                          errorsText={errors.password}
                          labelClass="bg-white"
                          icon={
                            <p
                              className="p-2 absolute top-1.5 right-0 rounded cursor-pointer bg-transparent z-20"
                              onClick={() => {
                                if (passwordType === "password") {
                                  setPasswordType("text");
                                  return;
                                }
                                setPasswordType("password");
                              }}
                            >
                              {passwordType === "password" ? (
                                <EyeSlash size="20" />
                              ) : (
                                <>
                                  <Eye size="20" />
                                </>
                              )}
                            </p>
                          }
                        />
                        {/* Confirm New Password */}
                        <InputWithLabel
                          className={`border border-gray ${
                            errors.confirmPassword && touched.confirmPassword
                              ? "border-red"
                              : values.confirmPassword
                              ? "border-themeBtn"
                              : ""
                          }`}
                          idFromName="confirmPassword"
                          label="Confirm New Password"
                          type={confirmPasswordType}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.confirmPassword}
                          errors={
                            errors.confirmPassword && touched.confirmPassword
                          }
                          labelClass="bg-white"
                          errorsText={errors.confirmPassword}
                          icon={
                            <p
                              className="p-2 absolute top-1.5 right-0 rounded cursor-pointer bg-transparent z-20"
                              onClick={() => {
                                if (confirmPasswordType === "password") {
                                  setConfirmPasswordType("text");
                                  return;
                                }
                                setConfirmPasswordType("password");
                              }}
                            >
                              {confirmPasswordType === "password" ? (
                                <EyeSlash size="20" />
                              ) : (
                                <>
                                  <Eye size="20" />
                                </>
                              )}
                            </p>
                          }
                        />
                        <button
                          type="submit"
                          disabled={loading}
                          className="w-full block text-bgWhite font-normal bg-themeBtn text-center text-[15px] border-2 border-transparent uppercase hover:bg-transparent hover:border-2 hover:border-themeBtn hover:text-themeBtn rounded transition duration-500 py-2 lg:px-7 px-4 mt-3"
                        >
                          {loading ? "loading..." : "Conform new password"}
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default NewPassword;
